export function clearPhone(phone: string): string {
  return phone.replace(/\D/g, '');
}

export function normalizePhoneForBackend(phone: string): string | null {
  const digits = clearPhone(phone);

  if (digits.length === 10) {
    return `+7${digits}`;
  }

  if (digits.length === 11 && ['7', '8'].includes(digits[0] ?? '')) {
    return `+7${digits.slice(1)}`;
  }

  return null;
}
